<script>
import Template from "../Template.vue";

export default {
  props: ['projectId'],
  components: {Template},
  data() {
    return {
      token: '2|tnhfUH2xBeR899A1kamgnzOpClKdlQVbb8cqCwJVc21cd6d2',
      organizationSearchQuery: null,
      formSearchQuery: null,
      organizationSearchResults: [],
      formSearchResults: [],
      linkId: null,
      organizationId: null,
      linkData: [],
      fieldData: [],
      formData: [],
      fieldResult: [],
      pressets: [],
      pressetId: 0
    }
  },
  methods: {
    loadPresset(key){
      console.log(this.formData)
      let data = this.pressets[key];
      data.fields.forEach((item, i) => {
        if(item){
          if(this.formData[i]){
            console.log(this.formData[i])
          }
        }
      });

      this.draftId = key;
    },
    deletePresset(key){
      Swal.fire({
        title: 'Вы уверены?',
        text: "Это действие нельзя будет отменить",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Да, удалить',
        cancelButtonText: 'Отмена'
        }).then((result) => {
         if (result.value) {
           this.pressets.splice(key, 1);
           window.localStorage.setItem('pressets', JSON.stringify(this.pressets));
        }
      })
    },
    loadPressets(){
      let pressetsData = JSON.parse(window.localStorage.getItem('pressets'));
      if(pressetsData && pressetsData.length > 0){
        this.pressets = pressetsData;
      }
    },
    savePreset(){
      let temp = [];
      this.formData.forEach((item, i) => {
        if(item.field_id){
          temp[i] = item.field_id;
        }
      });

      Swal.fire({
        title: "Введите наименование пресета",
        input: 'text',
        showCancelButton: true,
        cancelButtonText: 'Отмена',
        confirmButtonText: 'Сохранить'
      }).then((result) => {
        if (result.value) {
          let output = {
            project_id: this.projectId,
            name: result.value,
            fields: temp
          };

          let pressetsData = JSON.parse(window.localStorage.getItem('pressets'));
          if(!pressetsData){
            this.pressetId = 0;
            pressetsData = [];
          }

          pressetsData[this.pressetId] = output;
          window.localStorage.setItem('pressets', JSON.stringify(pressetsData));
        }
      });
    },
    closeModal(){
      this.pressetId = 0;
      this.linkData = [];
      this.formData = [];
      this.fieldResult = [];
      this.organizationId = null;
      this.linkId = null;
      this.organizationSearchResults = [];
      this.formSearchResults = [];
      this.formSearchQuery = null;
      this.organizationSearchQuery = null;
      $('#importModal').modal('hide');
    },
    searchForm() {
      this.linkId = null;
      this.linkData = [];
      axios.get('https://forms.uibcom.ru/api/links_list?search=' + this.formSearchQuery, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + this.token,
        }
      }).then(response => {
        this.formSearchResults = response.data.data;
      })
    },
    searchOrganization() {
      this.organizationId = null;
      axios.get('/api/project/' + this.projectId + '/organization?search=' + this.organizationSearchQuery).then(response => {
        this.organizationSearchResults = response.data.data;
      })
    },
    dropFormSearch() {
      this.linkId = null;
      this.formSearchResults = [];
      this.formSearchQuery = null;
    },
    dropOrganizationSearch() {
      this.organizationId = null;
      this.organizationSearchResults = [];
      this.organizationSearchQuery = null;
    },
    // searchField(value, data_id, index = null) {
    //   this.fieldResult = [];
    //   console.log(value)
    //   console.log(this.$refs['fieldResult_' + data_id + '_' + index])
    //   this.fieldResult = this.fieldData.filter((item) => {
    //     return item.name.includes(value);
    //   })
    // },
    selectForm(result) {
      this.formSearchQuery = result.name;
      this.linkId = result.id;
      this.formSearchResults = [];
    },
    selectOrganization(result) {
      this.organizationSearchQuery = result.name;
      this.organizationId = result.id;
      this.organizationSearchResults = [];
    },
    // selectField(result, data_id, field_index) {
    //
    // },
    async linkDataRequest() {
      await axios.get('https://forms.uibcom.ru/api/links/' + this.linkId, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + this.token,
        }
      }).then(response => {
        this.linkData = response.data;
        this.linkData.data.forEach(data => {
          let field_data = null;
          if(typeof data.value === 'object' && data.value.length > 1) {
            field_data = [];
            for(let i = 0; i < data.value.length; i++) {
              field_data.push(null);
            }
          }
          this.formData[data.id] = {
            field_id: field_data,
            value: data.value,
          }
        });
      })
    },
    fieldDataRequest() {
      axios.get('/api/project/' + this.projectId + '/field/list').then(response => {
        this.fieldData = response.data;
      })
    },
    mutateMultiple(data, value) {
      let field_data = null;
      if(value) {
        field_data = [];
        if(data.value.length === 1) {
          for(let i = 0; i < data.value[0].length; i++) {
            field_data.push(null);
          }
        }
        else if(data.value.length > 1) {
          for(let i = 0; i < data.value.length; i++) {
            let sub_level = [];
            for(let b = 0; b < data.value[i].length; b++) {
              sub_level.push(null);
            }
            field_data.push(sub_level);
          }
        }
      }
      else {
        if(data.value.length > 1) {
          field_data = [];
          for(let i = 0; i < data.value.length; i++) {
            field_data.push(null);
          }
        }
      }
      let newArray = {
        field_id: field_data,
        value: data.value,
        isMutate: value,
      }
      this.formData.splice(data.id, 1, newArray)
    },
    save() {
      axios.post('/api/organization/' + this.organizationId + '/import', this.formData).then(response => {
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
        this.$emit('orgsUpdate');
        this.closeModal();
      }).catch(error => {
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      });
    }
  },
  created() {
    this.fieldDataRequest();
    // this.loadPressets();
  }
}
</script>

<template>
  <!-- Field Add/Edit Modal -->
  <div class="modal fade" id="importModal" tabindex="-1" role="dialog" aria-hidden="true" data-focus="false" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-xl">
      <div class="modal-content pt-0" style="min-height: 400px">
        <div class="modal-header mb-1">
          <h5 class="modal-title">Импорт данных со сборщика данных</h5>
          <button type="button" class="close" @click="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="d-grid grid-template-rows-2 grid-gap-10 mb-1">
            <div class="form-group position-relative">
              <label>Проект</label>
              <div class="d-flex justify-content-between w-100">
                <div class="input-group input-group-merge shadow-none m-0 flex-grow-1 border-color-standard">
                  <div class="input-group-prepend border-color-standard">
                  <span class="input-group-text border-color-standard" :class="{ 'border-bottom-0 border-top-left-radius': organizationSearchResults.length > 0}">
                    <font-awesome-icon icon="fas fa-search" />
                  </span>
                  </div>
                  <input type="text" @input="searchOrganization()" v-model="organizationSearchQuery" class="form-control files-filter bg-transparent hover-none border-color-standard border-right" :class="{ 'rounded-right': organizationSearchResults.length === 0 && !organizationSearchQuery, 'border-bottom-0': organizationSearchResults.length > 0, 'border-right-0': organizationSearchResults.length > 0 || organizationSearchQuery}" placeholder="Поиск" />
                  <div class="input-group-prepend border-color-standard" style="margin-right: 0.1px">
                    <button type="button" @click="dropOrganizationSearch()" v-show="organizationSearchResults.length > 0 || organizationSearchQuery" class="input-group-text border-color-standard border-left-0 border-right" :class="{ 'rounded-right': organizationSearchResults.length === 0, 'border-bottom-0 border-top-right-radius': organizationSearchResults.length > 0}">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="organizationSearchResults.length > 0" class="position-absolute overflow-y-scroll zindex-2 w-100 bg-white border border-top-0 rounded-bottom border-color-standard" style="max-height: 200px">
                <button type="button" @click="selectOrganization(result)" v-for="result in organizationSearchResults" :key="result.id" class="input-group-text border-0 cursor-pointer w-100">{{result.name}}</button>
              </div>
              <p class="font-small-3">Введите наименование организации, к которой вы хотите импортировать данные.</p>
            </div>
          </div>
          <div class="d-grid grid-template-rows-2 grid-gap-10">
            <div class="form-group position-relative">
              <label>Форма</label>
              <div class="d-flex justify-content-between w-100">
                <div class="input-group input-group-merge shadow-none m-0 flex-grow-1 border-color-standard">
                  <div class="input-group-prepend border-color-standard">
                  <span class="input-group-text border-color-standard" :class="{ 'border-bottom-0 border-top-left-radius': formSearchResults.length > 0}">
                    <font-awesome-icon icon="fas fa-search" />
                  </span>
                  </div>
                  <input type="text" @input="searchForm()" v-model="formSearchQuery" class="form-control files-filter bg-transparent hover-none border-color-standard border-right" :class="{ 'rounded-right': formSearchResults.length === 0 && !formSearchQuery, 'border-bottom-0': formSearchResults.length > 0, 'border-right-0': formSearchResults.length > 0 || formSearchQuery}" placeholder="Поиск" />
                  <div class="input-group-prepend border-color-standard" style="margin-right: 0.1px">
                    <button type="button" @click="dropFormSearch()" v-show="formSearchResults.length > 0 || formSearchQuery" class="input-group-text border-color-standard border-left-0 border-right" :class="{ 'rounded-right': formSearchResults.length === 0, 'border-bottom-0 border-top-right-radius': formSearchResults.length > 0}">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="formSearchResults.length > 0" class="position-absolute overflow-y-scroll zindex-1 w-100 bg-white border border-top-0 rounded-bottom border-color-standard" style="max-height: 200px">
                <button type="button" @click="selectForm(result)" v-for="result in formSearchResults" :key="result.id" class="input-group-text border-0 cursor-pointer w-100">{{result.name}}</button>
              </div>
              <p class="font-small-3">Введите наименование формы из сборщика данных. Доступны только заполненные формы. Из выбранной формы подтянутся даные</p>
            </div>
            <button class="compose btn btn-primary" :class="{'btn-secondary pointer-events-none': !linkId || !organizationId}" @click="linkDataRequest()" :disabled="!linkId || !organizationId">Получить данные по ссылке</button>
          </div>

          <!-- <div class="row mt-2" v-if="linkData.data && linkId && organizationId && fieldData.length > 0 && pressets && pressets.length > 0">
            <div class="col-12 col-md-2 mb-3" v-for="(presset, key) in pressets">
              <div class="card border basic-pricing h-100">
                <div class="card-body d-flex flex-column">
                  <h3>{{presset.name}}</h3>

                  <div class="d-flex justify-content-between align-items-center mt-auto">
                    <button @click="loadPresset(key)" class="btn btn-outline-success"><font-awesome-icon icon="fas fa-eye" /></button>
                    <button @click="deletePresset(key)" class="btn btn-outline-danger"><font-awesome-icon icon="fas fa-trash" /></button>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <div class="d-flex justify-content-center align-items-stretch flex-wrap mt-2" style="gap: 30px 100px;" v-if="linkData.data && linkId && organizationId && fieldData.length > 0">
            <div v-for="data in linkData.data" :key="data.id" class="card p-50" style="max-width: 600px; width: 100%">
              <div v-if="data.field.additional_fields && typeof data.value === 'object'">
                <div v-if="data.value.length > 1">
                  <div class="mb-1">
                    <span class="font-medium-5 font-weight-bold">{{data.field.name}}<br></span>
                    <div class="form-check">
                      <input @change="mutateMultiple(data, $event.target.checked)" type="checkbox" class="form-check-input"/>
                      <label class="form-check-label">Разделить поля</label>
                    </div>
                  </div>
                  <div v-for="(sub_value, index) in data.value" class="d-flex justify-content-between align-items-center">
                    <div v-if="!formData[data.id].isMutate" class="border-bottom mb-1">
                      <div class="d-flex flex-column mb-1">
                        <div v-for="(additional_field, sub_index) in data.field.additional_fields">
                          <span class="font-medium-1 mr-1">{{additional_field}}: {{sub_value[sub_index]}}</span>
                        </div>
                      </div>
                      <select v-model="formData[data.id].field_id[index]" class="form-select" style="max-width: 200px; height: 30px; margin-bottom: 5px">
                        <option v-for="field in fieldData" :key="field.id" :value="field.id">{{field.description}}</option>
                      </select><br>
                    </div>
                    <div v-else>
                      <div class="d-flex flex-column border-bottom mb-1">
                        <div v-for="(additional_field, sub_index) in data.field.additional_fields" class="mb-1">
                          <span class="font-medium-1 mr-1">{{additional_field}}: {{sub_value[sub_index]}}</span>
                          <select v-model="formData[data.id].field_id[index][sub_index]" class="form-select" style="max-width: 200px; height: 30px">
                            <option v-for="field in fieldData" :key="field.id" :value="field.id">{{field.description}}</option>
                          </select><br>
                        </div>
                      </div>
                    </div>
                    <!--                    <div class="position-relative">-->
                    <!--                      <div class="d-flex justify-content-between w-100">-->
                    <!--                        <div class="input-group input-group-merge shadow-none m-0 flex-grow-1 border-color-standard">-->
                    <!--                          <div class="input-group-prepend border-color-standard">-->
                    <!--                        <span class="input-group-text border-color-standard" :class="{ 'border-bottom-0 border-top-left-radius': fieldResult.length > 0}">-->
                    <!--                          <font-awesome-icon icon="fas fa-search" />-->
                    <!--                        </span>-->
                    <!--                          </div>-->
                    <!--                          <input type="text" @input="searchField($event.target.value, data.id, index)" v-model="formData[data.id].field_id[index]" class="form-control files-filter bg-transparent hover-none border-color-standard" :class="{ 'border-bottom-0 border-top-right-radius': fieldResult.length > 0}" placeholder="Поиск" />-->
                    <!--                        </div>-->
                    <!--                      </div><br>-->
                    <!--                      <div v-if="fieldResult.length > 0" :ref="'fieldResult_' + data.id + '_' + index" class="list position-absolute overflow-scroll zindex-2 w-100 bg-white border border-top-0 rounded-bottom border-color-standard" style="max-height: 200px">-->
                    <!--                        <button type="button" @click="selectField(result, data.id, index)" v-for="result in fieldResult" :key="result.id" class="input-group-text border-0 cursor-pointer w-100">{{result.name}}</button>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </div>
                </div>
                <div v-else>
                  <div class="mb-1">
                    <span class="font-medium-5 font-weight-bold">{{data.field.name}}<br></span>
                    <div class="form-check">
                      <input @change="mutateMultiple(data, $event.target.checked)" type="checkbox" class="form-check-input"/>
                      <label class="form-check-label">Разделить поля</label>
                    </div>
                  </div>
                  <div v-if="!formData[data.id].isMutate">
                    <div v-for="(additional_field, index) in data.field.additional_fields" class="mb-1">
                      <span class="font-medium-1 mr-1">{{additional_field}}: {{data.value[0][index]}}</span><br>
                    </div>
                    <select v-model="formData[data.id].field_id" class="form-select" style="max-width: 200px; height: 30px">
                      <option v-for="field in fieldData" :key="field.id" :value="field.id">{{field.description}}</option>
                    </select>
                  </div>
                  <div v-else>
                    <div v-for="(sub_value, index) in data.value[0]" class="mb-1">
                      <span class="font-medium-1 mr-1">{{data.field.additional_fields[index]}}: {{sub_value}}</span>
                      <select v-model="formData[data.id].field_id[index]" class="form-select" style="max-width: 200px; height: 30px">
                        <option v-for="field in fieldData" :key="field.id" :value="field.id">{{field.description}}</option>
                      </select><br>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="font-medium-5 font-weight-bold mb-1">{{data.field.name}}</span>
                <div class="d-flex align-items-center gap-1">
                  <span class="font-medium-1 mr-1">{{data.value}}</span>
                  <select v-model="formData[data.id].field_id" class="form-select" style="max-width: 200px; height: 30px">
                    <option v-for="field in fieldData" :key="field.id" :value="field.id">{{field.description}}</option>
                  </select><br>
                </div>
              </div>
              <br>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-2" v-if="linkId && linkData.data && linkData.data.length > 0 && organizationId && fieldData.length > 0">
            <!-- <button @click="savePreset()" class="btn btn-secondary" type="button" name="button">Сохранить Прессет</button> -->
            <button type="button" @click="save()" class="btn btn-primary">Сохранить организацию</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- !Field Add/Edit Modal -->
</template>

<style scoped>
.list {
  display: none !important;
}
.list.active {
  display: block !important;
}
.border-top-right-radius {
  border-radius: 0;
  border-top-right-radius: 0.25rem !important;
}
.border-top-left-radius {
  border-radius: 0;
  border-top-left-radius: 0.25rem !important;
}
.border-color-standard{
  border-color: #d8d6de !important;
}
.overflow-y-scroll {
  overflow-y: scroll !important;
  overflow-x: unset !important;
  scrollbar-color: #7367f0 #ffffff !important;
}
::-webkit-scrollbar {
  width: 5px;
}
</style>
